import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = () => new Vuex.Store({

  state: {
    closeFlag: false,
    pressList: [
      // {
      //   title: '深圳市鲲鹏快付有限公司严正声明!',
      //   date: '2023-03-07',
      //   path: '/solemnStatement',
      // },
      {
        title: '《中国石油“昆仑易融”平台推介交流会长庆油田分会场》',
        date: '2023-05-12',
        path: '/news/klyr',
      },
      {
        title: '《昆仑数智与工行深圳分行签订供应链金融服务战略合作协议》',
        date: '2023-03-05',
        path: '/news/klsz',
      },
      {
        title: '《工行北京分行与昆仑数智签署供应链金融服务战略合作协议》',
        date: '2023-01-15',
        path: '/news/icbc',
      },
    ]
  },
  mutations: {
    SET_CLOSE_FLAG (state, value) {
      state.closeFlag = value || false
    }
  }
})

export default store
